import { SubContractPaymentUpdateStateTypes, SubContractPaymentUpdateActionTypes } from "./SubContractPaymentUpdate.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SubContractPaymentUpdateStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SubContractPaymentUpdateReducer = (
  state: SubContractPaymentUpdateStateTypes = INITIAL_STATE,
  action: any
): SubContractPaymentUpdateStateTypes => {
  switch (action.type) {
    case SubContractPaymentUpdateActionTypes.FETCH_ALL_SUB_CONTRACT_PAYMENT_UPDATE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SubContractPaymentUpdateActionTypes.FETCH_ALL_SUB_CONTRACT_PAYMENT_UPDATE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SubContractPaymentUpdateActionTypes.FETCH_ALL_SUB_CONTRACT_PAYMENT_UPDATE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SubContractPaymentUpdateActionTypes.FETCH_ALL_SUB_CONTRACT_PAYMENT_UPDATE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SubContractPaymentUpdateActionTypes.FETCH_ONE_SUB_CONTRACT_PAYMENT_UPDATE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SubContractPaymentUpdateActionTypes.FETCH_ONE_SUB_CONTRACT_PAYMENT_UPDATE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SubContractPaymentUpdateActionTypes.FETCH_ONE_SUB_CONTRACT_PAYMENT_UPDATE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SubContractPaymentUpdateActionTypes.FETCH_ONE_SUB_CONTRACT_PAYMENT_UPDATE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SubContractPaymentUpdateReducer;
